const API_BASE_URL = process.env.REACT_APP_API_DOMAIN;
const API_VERSION = "v1";

const API_PATH = {
  GET_URL_TOKEN: `${API_BASE_URL}/${API_VERSION}/token`,
  GET_URL_TOKEN_INFO: `${API_BASE_URL}/${API_VERSION}/tokenInfo`,
  GET_URL_LINELOGINAUTH: `${API_BASE_URL}/${API_VERSION}/lineLoginAuth`,
  GET_URL_REGISTER: `${API_BASE_URL}/${API_VERSION}/register`,
  GET_URL_USERHOME: `${API_BASE_URL}/${API_VERSION}/userHome`,
  GET_URL_SENDMOBILEAUTH: `${API_BASE_URL}/${API_VERSION}/sendMobileAuth`,
  GET_URL_MOBILEAUTH : `${API_BASE_URL}/${API_VERSION}/mobileAuth`,
  GET_URL_USERPROFILE : `${API_BASE_URL}/${API_VERSION}/userProfile`,
  GET_URL_UPDATEUSERPROFILE : `${API_BASE_URL}/${API_VERSION}/updateUserProfile`,
  GET_URL_PLATES : `${API_BASE_URL}/${API_VERSION}/plates`,
  GET_URL_MEMBERPROFILE : `${API_BASE_URL}/${API_VERSION}/memberProfile`,
  GET_URL_ADDPLATES : `${API_BASE_URL}/${API_VERSION}/addPlates`,
  GET_URL_UPDATEPLATES : `${API_BASE_URL}/${API_VERSION}/updatePlates`,
  GET_URL_PAYMENTINFO : `${API_BASE_URL}/${API_VERSION}/paymentInfo`,
  GET_URL_UPDATEPAYMENTINFO : `${API_BASE_URL}/${API_VERSION}/updatePaymentInfo`,
  GET_URL_REMOVEPAYMENT : `${API_BASE_URL}/${API_VERSION}/removePayment`,
  GET_URL_LINEUSER : `${API_BASE_URL}/${API_VERSION}/lineUser`,
  GET_URL_Lots : `${API_BASE_URL}/${API_VERSION}/lots`,
  GET_URL_BIND_CREDIT_CARD : `${API_BASE_URL}/${API_VERSION}/bindCreditCard`,
  GET_URL_BIND_LINE_PAY : `${API_BASE_URL}/${API_VERSION}/bindLinePay`,
  GET_URL_INVOICE : `${API_BASE_URL}/${API_VERSION}/invoiceDevice`,
  GET_URL_ADDINVOICEDEVICE : `${API_BASE_URL}/${API_VERSION}/addInvoiceDevice`,
  GET_URL_UPDATEINVOICEDEVICE : `${API_BASE_URL}/${API_VERSION}/updateInvoiceDevice`,
  GET_URL_CURRENTSTATUS : `${API_BASE_URL}/${API_VERSION}/currentStatus`,
  GET_URL_HISTORY : `${API_BASE_URL}/${API_VERSION}/history`,
  
};





export {API_VERSION};
export default API_PATH;